import React from "react";
import DynamicTable from "../../common/components/DynamicTable";
import DefaultToolbar from "../../common/components/DynamicTable/DefaultToolbar";
import { Link } from "react-router-dom";

function CompanyCellRenderer({ row, head }) {
  const { label } = head;
  const { soldCompanyId, soldCompanyName } = row;
  return (
    <td
      className={`DynamicTableData__Cell__${(label || "").replace(" ", "_")}`}
    >
      {soldCompanyName && soldCompanyId && <Link to={`/companies/${soldCompanyId}`}>{soldCompanyName}</Link>}
    </td>
  );
}

export default function Page() {
  return (
    <>
      <h1>Upgrade Program</h1>

      <DynamicTable
        endpoint="/upgrades/table"
        toolbarRenderer={DefaultToolbar}
        fields={{
          soldCompanyName: {
            cellRenderer: CompanyCellRenderer,
          },
        }}
      />
    </>
  );
}
